export const weekdayHU = [
  { id: 0, name: 'Vasárnap', shortName: 'V' },
  { id: 1, name: 'Hétfő', shortName: 'H' },
  { id: 2, name: 'Kedd', shortName: 'K' },
  { id: 3, name: 'Szerda', shortName: 'Sze' },
  { id: 4, name: 'Csütörtök', shortName: 'Cs' },
  { id: 5, name: 'Péntek', shortName: 'P' },
  { id: 6, name: 'Szombat', shortName: 'Szo' },
];